export class OrderTrackingCodeModel {
    trackingCode: string = "";

    constructor(t?: Partial<OrderTrackingCodeModel>) {
        Object.assign(this, t)
    }

    isValid():boolean {
        return true;
    }
}
